import { StoryMarkdown } from '@/components/story-markdown'

interface Props {
    keywordBody: string
}

// Row 4 — Heisig's canonical narrative (or user/kanjido override) for the
// keyword. The on-the-primitive aside lives in its own row (PrimitiveAside)
// so it can be revealed after the stroke order per locked Learn spec §48.
//
// 17px mobile / 19px desktop with leading-prose (1.7).
//
// StoryMarkdown parses the embedded HTML (the Heisig corpus uses `<i>` tags
// inside markdown), then sanitizes against the narrow story whitelist —
// defence in depth against any unsafe tag slipping in via a future
// content edit.
export function StoryProse({ keywordBody }: Props) {
    return (
        <StoryMarkdown className="text-justify font-serif text-[17px] leading-prose text-pretty hyphens-auto text-body-fg md:text-[19px] [&_p]:leading-prose [&_strong]:font-semibold [&_strong]:text-ink">
            {keywordBody}
        </StoryMarkdown>
    )
}
